import { z } from 'zod'
import { nullSafeOptionalString } from '../shared/schema'

export const schema = z.object({
  mediaId: nullSafeOptionalString(),
})

export type FirestoreSettingsDefaultProcessingAsset = z.infer<typeof schema>

export const empty: FirestoreSettingsDefaultProcessingAsset = Object.freeze(
  schema.parse({
    mediaId: '',
  })
)
